import { jwtDecode, JwtPayload } from 'jwt-decode';
import { isBrowser } from '~/constants';
import { SessionData } from '~/sessions';
import { getCookie, getCookieValue } from './cookies';

export function isTokenExpired(token: string | undefined): boolean {
    if (!token) {
        return true;
    }
    const { exp } = jwtDecode<JwtPayload>(token);
    return !exp || Date.now() >= exp * 1000;
}

export function getToken(request?: Request): string | undefined {
    if (!isBrowser) {
        if (!request) {
            console.log('No request provided in getToken on server side');
            return undefined;
        }
        const cookieHeader = request.headers.get('Cookie');
        const session = JSON.parse(
            atob(getCookieValue(cookieHeader, '__session') as string)
        );
        return session.token;
    }
    const session: Partial<SessionData> = JSON.parse(
        atob(getCookie('__session'))
    );

    return session.token;
}
